import React from 'react';
import './Button.css';
import { Link } from 'react-router-dom';

export default function Button({ variant, text, url }) {
  return (
    <Link to={url}>
      <div className='Button'>
        <button className={`Button-btn Button-btn-${variant}`}>
          {text} <span className="Button-btn-arrow">→</span>
        </button>
      </div>
    </Link>
  )
}
